import { render } from "./TemaAvfall.vue?vue&type=template&id=6cad85a4"
import script from "./TemaAvfall.vue?vue&type=script&lang=js"
export * from "./TemaAvfall.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__